exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nsection[data-v-444524ec]{\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n    gap: 10px;\n}\ninput[type=\"radio\"][data-v-444524ec] {\r\n  display: none;\n}\nlabel[data-v-444524ec] {\r\n  position: relative;\r\n  min-width: 48px;\r\n  min-height: 34px;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n  border-radius: 20px;\r\n  background-color: #ccc;\r\n  transition: all 0.2s ease-in-out;\r\n  padding-inline: 12px;\r\n  font-weight: normal;\r\n  font-size: 14px;\n} \r\n/* input[type=\"radio\"]:checked ~ span {\r\n  color: red;\r\n} */\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-444524ec","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/referral/referrals-filter.vue
// module id = 601
// module chunks = 0